import { TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";

import { TableCellBorderless } from "../styled";

interface Props {
  columns: any;
}

export const InvoiceTitleRow = ({ columns }: Props) => {
  const { t } = useTranslation("invoices");

  return (
    <TableRow>
      {columns.map((column: any) => (
        <TableCellBorderless key={column.invoiceFieldName}>
          {t(column.translationKey)}
        </TableCellBorderless>
      ))}
      <TableCellBorderless />
    </TableRow>
  );
};
